import firebase from "./../Firebase";
import { useState } from "react";
import ParamsType, { HandleNameChangeInterface, User } from "./../types/Types";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router";
import { useCollectionData } from "react-firebase-hooks/firestore";

const { Picker } = require("emoji-mart");

const ChatRoomSubmit = () => {
  const { id } = useParams<ParamsType>();
  const db = firebase.firestore();
  const [newMessage, setMessage] = useState("");
  const [emojiPickerState, SetEmojiPicker] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const query = db.collection("users").where("isTyping", "==", true);
  const [typingUsers] = useCollectionData(query, { idField: "id" });
  const user = firebase.auth()?.currentUser;

  console.log(creatrChatID());
  const messagesDB = id ? db.collection(`${creatrChatID()}` || "") : db.collection("messages");

  function creatrChatID() {
    if (user != null) {
      const chatterID = user.uid;
      const chateeID = id;
      const chatIDpre = [];
      chatIDpre.push(chatterID);
      chatIDpre.push(chateeID);
      chatIDpre.sort();
      return chatIDpre.join("_");
    }
  }

  const userObj: Partial<User> =
    user != null
      ? {
          uid: user.uid,
          photoURL: user.photoURL,
          displayName: user.displayName,
          isOnline: true,
          isTyping: false,
        }
      : {};

  const userStatusFirestoreRef = firebase.firestore().doc("/users/" + userObj.uid);

  async function typeMessage(event: HandleNameChangeInterface) {
    setMessage(event.target?.value);
    userStatusFirestoreRef.update({ isTyping: true });
  }

  function showTypingUsers() {
    const names = typingUsers?.map((user) => user.displayName);

    if (typingUsers?.some((userId) => userId?.uid === userObj.uid)) {
      return;
    }

    if (!names || names.length === 0) {
      return;
    }

    const status = names.length === 1 ? `User ${names} is typing...` : `Users ${names?.[0]} and ${names?.[1]} is typing...`;
    return status;
  }

  function sendMessage(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    const message = newMessage?.trim();

    if (message.length !== 0 || fileUrl.length !== 0) {
      messagesDB.add({
        text: message,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        uid: userObj.uid,
        photoURL: userObj.photoURL,
        displayName: userObj.displayName,
        img: fileUrl,
        isLiked: false,
      });

      setMessage("");
      setFileUrl("");
    }
  }

  function triggerPicker(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    SetEmojiPicker(!emojiPickerState);
  }

  async function onFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (!event.target.files) return;

    const file = event.target.files[0];
    const storageRef = firebase.storage().ref();
    const fileRef = storageRef.child(file.name);
    await fileRef.put(file);
    setFileUrl(await fileRef.getDownloadURL());
  }

  return (
    <div className="submit-area">
      <input onChange={typeMessage} value={newMessage} type="text" placeholder=" Type your message here..." />
      <div className="typing-users">{showTypingUsers()}</div>
      <button onClick={triggerPicker} className="emoji-button">
        😁
      </button>
      <div className="picker-style">{emojiPickerState && <Picker emoji="point_up" onSelect={(emoji: any) => setMessage(newMessage + emoji.native)} />}</div>
      <input className="uploadFile-styles" type="file" hidden id="myuniqueid" onChange={onFileChange} />
      <label htmlFor="myuniqueid">Img</label>
      <button onClick={sendMessage} className="send-button">
        Send
      </button>
    </div>
  );
};

export default ChatRoomSubmit;
